import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=b896a942&scoped=true&"
var script = {}
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=b896a942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b896a942",
  null
  
)

export default component.exports